module.exports = __webpack_public_path__ + "c712e9c5d5ecb3e6f1cec4aa5f457e76.png";